import moment from 'moment'
import { format } from 'date-fns'

export const formatNumber = number => {
  return (+number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

export const formatCurrency = number =>
  `${+number < 0 ? '-' : ''}$${formatNumber(Math.abs(+number))}`

export const formatNumberOne = number => {
  return (+number).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

const gettimeDiff = date => {
  if (!date || !date.isValid()) {
    return null
  }
  return moment.duration(date.diff(moment()))
}

export const getStringTimeTo = date => {
  const diff = gettimeDiff(date)
  if (!diff) {
    return ''
  }
  return `${diff.get('days')} ${
    diff.get('days') === 1 ? 'day' : 'days'
  }, ${diff.get('hours')} hours, ${diff.get('minutes')} minutes`
}

export const getStringTimeToShort = date => {
  const diff = gettimeDiff(date)
  if (!diff) {
    return ''
  }
  let ret = []
  if (diff.get('days') > 0) {
    ret.push(`${diff.get('days')} ${diff.get('days') === 1 ? 'day' : 'days'}`)
  }
  if (diff.get('hours') > 0) {
    ret.push(
      `${diff.get('hours')} ${diff.get('hours') === 1 ? 'hour' : 'hours'}`
    )
  }
  if (ret.length === 0) {
    ret.push(date.format('h A'))
  }

  return ret.join(', ')
}

export const sendMessageToCustomerService = message => {
  if (window.Intercom) {
    window.Intercom('showNewMessage', message)
  }
}

export const openIntercom = () => {
  if (window.Intercom) {
    window.Intercom('show')
  }
}

export const getDayOfWeek = date => format(date, 'dddd')

export const formatTime = time => moment(time, 'HH:mm').format('h:mm A')



// WEBPACK FOOTER //
// ./src/utils/utils.js